'use strict';

import SubscriptionsEdit from './subscriptions.edit.ctrl';

export default angular
  .module('main.subscriptions', [
    SubscriptionsEdit
  ])
  .name;
